import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectItemMessageFormDataText = createSelector(
  [(store: RootState) => store.paymentNoticeDetail.itemMessageFormData.text],
  (text) => text
);
